// Map configuration
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

// Map styles
export const MAPBOX_STYLES = {
  LIGHT: "mapbox://styles/mapbox/light-v11",
  DARK: "mapbox://styles/mapbox/dark-v11",
  STREETS: "mapbox://styles/mapbox/streets-v9",
  SATELLITE: "mapbox://styles/mapbox/satellite-v9",
  SATELLITE_STREETS: "mapbox://styles/mapbox/satellite-streets-v12",
  NAVIGATION_DAY: "mapbox://styles/mapbox/navigation-day-v1",
  NAVIGATION_NIGHT: "mapbox://styles/mapbox/navigation-night-v1",
};

// Default map settings
export const DEFAULT_MAP_SETTINGS = {
  zoom: 12,
  center: [9.1824, 45.4685], // Milan in [longitude, latitude] format
  style: MAPBOX_STYLES.LIGHT,
};
